export const supervisaoEstabelecimentoSecoes = [
    {
        codigo: '1',
        titulo: 'Edificação e instalações',
        subgrupos: [
            {
                codigo: '1.1',
                titulo: 'Área externa',
                itens: [
                    { codigo: '1.1.1', descricao: 'Área externa livre de focos de insalubridade, objetos em desuso, vetores, lixo, água estagnada e outros.' },
                    { codigo: '1.1.2', descricao: 'Vias de acesso interno com superfície dura ou pavimentada, adequada ao trânsito sobre rodas.' },
                    { codigo: '1.1.3', descricao: 'Vias de acesso à área industrial apresentam escoamento adequado e limpas.' },
                    { codigo: '1.1.4', descricao: 'Em estabelecimentos de produtos lácteos, dispõe de instalações e equipamentos para ordenha, separados fisicamente das dependências industriais.' },
                    { codigo: '1.1.5', descricao: 'Área industrial com acesso direto, não comum a outros usos.' },
                ],
            },
            {
                codigo: '1.2',
                titulo: 'Área interna',
                itens: [
                    { codigo: '1.2.1', descricao: 'Área interna livre de objetos em desuso ou estranhos ao ambiente.' },
                ],
            },
            {
                codigo: '1.3',
                titulo: 'Instalações industriais',
                itens: [
                    { codigo: '1.3.1', descricao: 'Pisos com material que permite fácil higienização, resistente, drenado e impermeável.' },
                    { codigo: '1.3.2', descricao: 'Pisos em adequado estado de conservação.' },
                    { codigo: '1.3.3', descricao: 'Sistema de drenagem adequadamente dimensionado.' },
                    { codigo: '1.3.4', descricao: 'Drenos, ralos sifonados e grelhas em locais adequados.' },
                    { codigo: '1.3.5', descricao: 'Há forro na dependência.' },
                    { codigo: '1.3.6', descricao: 'Acabamento do teto/forro liso, cor clara, impermeável e de fácil limpeza.' },
                    { codigo: '1.3.7', descricao: 'Teto/forro em adequado estado de conservação.' },
                    { codigo: '1.3.8', descricao: 'Paredes/divisórias com acabamento liso, impermeável e de fácil higienização.' },
                    { codigo: '1.3.9', descricao: 'Paredes/divisórias em adequado estado de conservação.' },
                    { codigo: '1.3.10', descricao: 'Existência preferencial de ângulos abaulados entre paredes/piso e paredes/teto.' },
                    { codigo: '1.3.11', descricao: 'Pé-direito com altura suficiente para disposição adequada dos equipamentos.' },
                    { codigo: '1.3.12', descricao: 'Portas com superfície lisa, fácil higienização e ajustadas aos batentes.' },
                    { codigo: '1.3.13', descricao: 'Portas externas com fechamento automático ou barreiras adequadas.' },
                    { codigo: '1.3.14', descricao: 'Portas em adequado estado de conservação.' },
                    { codigo: '1.3.15', descricao: 'Janelas e outras aberturas com superfície lisa e fácil higienização.' },
                    { codigo: '1.3.16', descricao: 'Existência de proteção contra insetos e roedores.' },
                    { codigo: '1.3.17', descricao: 'Janelas e aberturas em adequado estado de conservação.' },
                    { codigo: '1.3.18', descricao: 'Escadas, elevadores e estruturas auxiliares construídos de forma a não serem fontes de contaminação.' },
                    { codigo: '1.3.19', descricao: 'Estruturas auxiliares de material apropriado, resistente, liso e impermeável.' },
                    { codigo: '1.3.20', descricao: 'Iluminação natural ou artificial adequada à atividade.' },
                    { codigo: '1.3.21', descricao: 'Luminárias com proteção adequada contra quebras.' },
                    { codigo: '1.3.22', descricao: 'Instalações elétricas embutidas ou revestidas por tubulações isolantes.' },
                    { codigo: '1.3.23', descricao: 'Ventilação e circulação de ar capazes de garantir conforto térmico e ambiente livre de contaminações.' },
                    { codigo: '1.3.24', descricao: 'Ventilação artificial com equipamento higienizado e com manutenção adequada.' },
                    { codigo: '1.3.25', descricao: 'Ambientes climatizados com filtros adequados.' },
                    { codigo: '1.3.26', descricao: 'Existência de registro periódico dos procedimentos de limpeza e manutenção da climatização.' },
                    { codigo: '1.3.27', descricao: 'Sistema de exaustão/insuflamento com troca de ar capaz de prevenir contaminações.' },
                    { codigo: '1.3.28', descricao: 'Sistema de exaustão/insuflamento dotado de filtros adequados.' },
                    { codigo: '1.3.29', descricao: 'Captação e direção da corrente de ar não seguem da área contaminada para área limpa.' },
                ],
            },
            {
                codigo: '1.4',
                titulo: 'Vestiários e sanitários',
                itens: [
                    { codigo: '1.4.1', descricao: 'Quando isolados da produção, acesso por passagens cobertas e calçadas.' },
                    { codigo: '1.4.2', descricao: 'Ausência de comunicação direta com área de trabalho e refeições.' },
                    { codigo: '1.4.3', descricao: 'Pisos e paredes adequadas e em satisfatório estado de conservação.' },
                    { codigo: '1.4.4', descricao: 'Iluminação e ventilação adequadas.' },
                    { codigo: '1.4.5', descricao: 'Instalações sanitárias em proporção adequada ao número de empregados.' },
                    { codigo: '1.4.6', descricao: 'Instalações servidas de água corrente e conectadas à rede de esgoto ou fossa séptica.' },
                    { codigo: '1.4.7', descricao: 'Disponibilidade de produtos de higiene pessoal.' },
                    { codigo: '1.4.8', descricao: 'Presença de lixeiras com acionamento não manual.' },
                    { codigo: '1.4.9', descricao: 'Coleta frequente do lixo.' },
                    { codigo: '1.4.10', descricao: 'Presença de avisos com procedimentos para lavagem das mãos.' },
                    { codigo: '1.4.11', descricao: 'Vestiários independentes, identificados e de uso exclusivo para manipuladores.' },
                    { codigo: '1.4.12', descricao: 'Vestiários com área compatível e armários individuais.' },
                    { codigo: '1.4.13', descricao: 'Duchas/chuveiros em número suficiente, quando necessários.' },
                    { codigo: '1.4.14', descricao: 'Apresentam-se organizados e em adequado estado de conservação.' },
                    { codigo: '1.4.15', descricao: 'Instalações sanitárias para visitantes independentes da produção, quando aplicável.' },
                ],
            },
            {
                codigo: '1.5',
                titulo: 'Higienização das instalações',
                itens: [
                    { codigo: '1.5.1', descricao: 'Existência de responsável capacitado pela operação de higienização.' },
                    { codigo: '1.5.2', descricao: 'Frequência de higienização adequada.' },
                    { codigo: '1.5.3', descricao: 'Produtos de higienização regularizados.' },
                    { codigo: '1.5.4', descricao: 'Disponibilidade dos produtos necessários.' },
                    { codigo: '1.5.5', descricao: 'Produtos identificados e guardados em local adequado.' },
                    { codigo: '1.5.6', descricao: 'Disponibilidade e adequação dos utensílios necessários.' },
                    { codigo: '1.5.7', descricao: 'Higienização adequada.' },
                ],
            },
            {
                codigo: '1.6',
                titulo: 'Controle integrado de vetores e pragas urbanas',
                itens: [
                    { codigo: '1.6.1', descricao: 'Ausência de vetores e pragas urbanas ou evidência de sua presença.' },
                    { codigo: '1.6.2', descricao: 'Adoção de medidas preventivas e corretivas.' },
                    { codigo: '1.6.3', descricao: 'Comprovante de execução do serviço, quando houver controle químico.' },
                ],
            },
            {
                codigo: '1.7',
                titulo: 'Abastecimento de água',
                itens: [
                    { codigo: '1.7.1', descricao: 'Sistema de abastecimento ligado à rede pública.' },
                    { codigo: '1.7.2', descricao: 'Sistema de captação própria protegido e distante de fonte de contaminação.' },
                    { codigo: '1.7.3', descricao: 'Reservatório de água acessível, em satisfatória condição de uso.' },
                    { codigo: '1.7.4', descricao: 'Existência de responsável pela higienização do reservatório.' },
                    { codigo: '1.7.5', descricao: 'Frequência apropriada de higienização do reservatório com registro.' },
                    { codigo: '1.7.6', descricao: 'Encanamento em estado satisfatório e sem conexão cruzada.' },
                    { codigo: '1.7.7', descricao: 'Rede diferenciada para água não potável, quando aplicável.' },
                    { codigo: '1.7.8', descricao: 'Disponibilidade de reagentes e equipamentos para análise da potabilidade.' },
                    { codigo: '1.7.9', descricao: 'Gelo produzido com água potável em condições sanitárias satisfatórias.' },
                    { codigo: '1.7.10', descricao: 'Vapor gerado a partir de água potável, quando em contato com alimento.' },
                    { codigo: '1.7.11', descricao: 'Há água fria e quente nas dependências de manipulação e preparo.' },
                ],
            },
            {
                codigo: '1.8',
                titulo: 'Manejo de subprodutos e resíduos',
                itens: [
                    { codigo: '1.8.1', descricao: 'Há instalações e equipamentos para recepção, armazenamento e expedição dos resíduos não comestíveis.' },
                    { codigo: '1.8.2', descricao: 'Equipamentos e utensílios exclusivos para produtos não comestíveis são identificados.' },
                    { codigo: '1.8.3', descricao: 'Recipientes de resíduos adequados, identificados e higienizados.' },
                    { codigo: '1.8.4', descricao: 'Retirada frequente dos resíduos da área de processamento.' },
                    { codigo: '1.8.5', descricao: 'Existência de área adequada para estocagem dos resíduos.' },
                ],
            },
            {
                codigo: '1.9',
                titulo: 'Esgotamento sanitário',
                itens: [
                    { codigo: '1.9.1', descricao: 'Fossas, esgoto e caixas de gordura em adequado estado de conservação e funcionamento.' },
                ],
            },
            {
                codigo: '1.10',
                titulo: 'Lavatórios na área de produção',
                itens: [
                    { codigo: '1.10.1', descricao: 'Existência de lavatórios na área de manipulação com água corrente e em número suficiente.' },
                    { codigo: '1.10.2', descricao: 'Lavatórios em condições de higiene, com sabonete, secagem e coletor sem contato manual.' },
                ],
            },
            {
                codigo: '1.11',
                titulo: 'Leiaute',
                itens: [
                    { codigo: '1.11.1', descricao: 'Leiaute adequado ao processo produtivo.' },
                    { codigo: '1.11.2', descricao: 'Áreas de recepção e depósito distintas das áreas de produção e expedição.' },
                ],
            },
        ],
    },
    {
        codigo: '2',
        titulo: 'Equipamentos, barreiras sanitárias, câmaras frias e móveis e utensílios',
        subgrupos: [
            {
                codigo: '2.1',
                titulo: 'Equipamentos',
                itens: [
                    { codigo: '2.1.1', descricao: 'Equipamentos da linha de produção com desenho e número adequado ao ramo.' },
                    { codigo: '2.1.2', descricao: 'Dispostos de forma a permitir fácil acesso e higienização adequada.' },
                    { codigo: '2.1.3', descricao: 'Superfícies em contato com alimentos lisas, íntegras, impermeáveis e atóxicas.' },
                    { codigo: '2.1.4', descricao: 'Em adequado estado de conservação e funcionamento.' },
                    { codigo: '2.1.5', descricao: 'Equipamentos de conservação e processamento térmico com medidor de temperatura.' },
                    { codigo: '2.1.6', descricao: 'Há equipamentos de controle de processo de fabricação.' },
                    { codigo: '2.1.7', descricao: 'Equipamentos de controle calibrados e aferidos.' },
                ],
            },
            {
                codigo: '2.2',
                titulo: 'Barreiras sanitárias',
                itens: [
                    { codigo: '2.2.1', descricao: 'Há barreiras sanitárias nos acessos à área de produção.' },
                    { codigo: '2.2.2', descricao: 'As barreiras sanitárias possuem equipamentos e utensílios específicos.' },
                ],
            },
            {
                codigo: '2.3',
                titulo: 'Câmaras frias',
                itens: [
                    { codigo: '2.3.1', descricao: 'Capacidade compatível com a quantidade produzida.' },
                    { codigo: '2.3.2', descricao: 'Paredes e separações facilitam higienização.' },
                    { codigo: '2.3.3', descricao: 'Paredes íntegras, sem fendas.' },
                    { codigo: '2.3.4', descricao: 'Pé-direito com altura suficiente.' },
                    { codigo: '2.3.5', descricao: 'Teto/forro de fácil higienização e em bom estado.' },
                    { codigo: '2.3.6', descricao: 'Pisos impermeabilizados e com drenagem adequada.' },
                    { codigo: '2.3.7', descricao: 'Luz natural ou artificial adequada.' },
                ],
            },
            {
                codigo: '2.4',
                titulo: 'Móveis',
                itens: [
                    { codigo: '2.4.1', descricao: 'Móveis em número suficiente, material apropriado e em adequado estado.' },
                    { codigo: '2.4.2', descricao: 'Desenho que permita fácil higienização.' },
                ],
            },
            {
                codigo: '2.5',
                titulo: 'Utensílios',
                itens: [
                    { codigo: '2.5.1', descricao: 'Material não contaminante, resistente à corrosão e em número suficiente.' },
                    { codigo: '2.5.2', descricao: 'Dispositivos de sanitização quando houver risco imediato de contaminação.' },
                    { codigo: '2.5.3', descricao: 'Armazenados em local apropriado, organizados e protegidos.' },
                ],
            },
            {
                codigo: '2.6',
                titulo: 'Higienização de equipamentos, máquinas, móveis e utensílios',
                itens: [
                    { codigo: '2.6.1', descricao: 'Existência de responsável capacitado pela higienização.' },
                    { codigo: '2.6.2', descricao: 'Frequência de higienização adequada.' },
                    { codigo: '2.6.3', descricao: 'Produtos de higienização regularizados.' },
                    { codigo: '2.6.4', descricao: 'Disponibilidade dos produtos necessários.' },
                    { codigo: '2.6.5', descricao: 'Produtos identificados e guardados em local adequado.' },
                    { codigo: '2.6.6', descricao: 'Disponibilidade e adequação dos utensílios necessários.' },
                    { codigo: '2.6.7', descricao: 'Adequada higienização.' },
                ],
            },
        ],
    },
    {
        codigo: '3',
        titulo: 'Manipuladores',
        subgrupos: [
            {
                codigo: '3.1',
                titulo: 'Vestuários',
                itens: [
                    { codigo: '3.1.1', descricao: 'Há uniformes suficientes e completos para a quantidade de funcionários.' },
                    { codigo: '3.1.2', descricao: 'Uso de uniforme de cor clara, adequado e exclusivo da área de produção.' },
                    { codigo: '3.1.3', descricao: 'Uniformes diferenciados por cor quando necessário.' },
                    { codigo: '3.1.4', descricao: 'Uniformes limpos e em adequado estado de conservação.' },
                    { codigo: '3.1.5', descricao: 'Há local adequado ou serviço terceirizado para higienização dos uniformes.' },
                    { codigo: '3.1.6', descricao: 'Há equipamentos adequados para higienização dos uniformes, quando feita internamente.' },
                    { codigo: '3.1.7', descricao: 'Asseio pessoal adequado dos manipuladores.' },
                    { codigo: '3.1.8', descricao: 'São tomadas precauções para visitantes não contaminarem os alimentos.' },
                ],
            },
            {
                codigo: '3.2',
                titulo: 'Programa de capacitação dos manipuladores',
                itens: [
                    { codigo: '3.2.1', descricao: 'Existência de programa de capacitação adequado e contínuo.' },
                    { codigo: '3.2.2', descricao: 'Cartazes de orientação sobre correta lavagem das mãos.' },
                    { codigo: '3.2.3', descricao: 'Orientação sobre lavagem cuidadosa das mãos.' },
                    { codigo: '3.2.4', descricao: 'Verificação pelo responsável técnico da higiene pessoal e manipulação.' },
                ],
            },
            {
                codigo: '3.3',
                titulo: 'Programa de controle de saúde',
                itens: [
                    { codigo: '3.3.1', descricao: 'Existência de verificação periódica do estado de saúde dos manipuladores.' },
                    { codigo: '3.3.2', descricao: 'Existência de registro dos exames e atestado de aptidão.' },
                    { codigo: '3.3.3', descricao: 'Utilização de EPI, quando necessário.' },
                ],
            },
        ],
    },
    {
        codigo: '4',
        titulo: 'Produção e transporte do alimento',
        subgrupos: [
            {
                codigo: '4.1',
                titulo: 'Matéria-prima, ingredientes e embalagens',
                itens: [
                    { codigo: '4.1.1', descricao: 'Recepção em local protegido e isolado da área de processamento.' },
                    { codigo: '4.1.2', descricao: 'Matérias-primas, ingredientes e embalagens inspecionados na recepção.' },
                    { codigo: '4.1.3', descricao: 'Itens aguardando liberação e aprovados devidamente identificados.' },
                    { codigo: '4.1.4', descricao: 'Reprovados devolvidos ou armazenados em local separado.' },
                    { codigo: '4.1.5', descricao: 'Rótulos da matéria-prima e ingredientes atendem à legislação.' },
                    { codigo: '4.1.6', descricao: 'Armazenamento em local adequado e organizado.' },
                    { codigo: '4.1.7', descricao: 'Uso respeita ordem de entrada e prazo de validade.' },
                    { codigo: '4.1.8', descricao: 'Acondicionamento adequado das embalagens a serem utilizadas.' },
                    { codigo: '4.1.9', descricao: 'Rede de frio adequada ao volume e tipos de matérias-primas e ingredientes.' },
                ],
            },
            {
                codigo: '4.2',
                titulo: 'Fluxo de produção',
                itens: [
                    { codigo: '4.2.1', descricao: 'Locais de pré-preparo isolados da área de preparo.' },
                    { codigo: '4.2.2', descricao: 'Controle da circulação e acesso do pessoal.' },
                    { codigo: '4.2.3', descricao: 'Conservação adequada de materiais destinados ao reprocessamento.' },
                    { codigo: '4.2.4', descricao: 'Fluxo ordenado, linear e sem cruzamento.' },
                ],
            },
            {
                codigo: '4.3',
                titulo: 'Rotulagem e armazenamento',
                itens: [
                    { codigo: '4.3.1', descricao: 'Dizeres de rotulagem com identificação visível e de acordo com a legislação.' },
                    { codigo: '4.3.2', descricao: 'Produto final acondicionado em embalagens adequadas e íntegras.' },
                    { codigo: '4.3.3', descricao: 'Alimentos armazenados separados por tipo/grupo e adequadamente afastados.' },
                    { codigo: '4.3.4', descricao: 'Ausência de material estranho, estragado ou tóxico.' },
                    { codigo: '4.3.5', descricao: 'Armazenamento em local limpo e conservado.' },
                    { codigo: '4.3.6', descricao: 'Rede de frio adequada ao volume e aos diferentes tipos de alimentos.' },
                    { codigo: '4.3.7', descricao: 'Produtos avariados ou vencidos identificados e armazenados em local separado.' },
                    { codigo: '4.3.8', descricao: 'Produtos finais em quarentena ou aguardando resultado analítico identificados.' },
                ],
            },
            {
                codigo: '4.4',
                titulo: 'Transporte',
                itens: [
                    { codigo: '4.4.1', descricao: 'Veículos/contentores com isolamento térmico ou equipamento gerador de frio.' },
                    { codigo: '4.4.2', descricao: 'Presença de equipamentos para controle de temperatura.' },
                    { codigo: '4.4.3', descricao: 'Carga e descarga realizadas fora dos locais de elaboração dos alimentos.' },
                    { codigo: '4.4.4', descricao: 'Veículos/contentores em bom estado, limpos e sem evidências de pragas.' },
                    { codigo: '4.4.5', descricao: 'Veículo não transporta outras cargas que comprometam a segurança do produto.' },
                    { codigo: '4.4.6', descricao: 'Produto transportado na temperatura especificada no rótulo.' },
                    { codigo: '4.4.7', descricao: 'Transporte mantém a integridade do produto.' },
                ],
            },
            {
                codigo: '4.5',
                titulo: 'Controle de qualidade do produto final',
                itens: [
                    { codigo: '4.5.1', descricao: 'Existência de equipamentos e materiais necessários para análise do produto final.' },
                ],
            },
        ],
    },
    {
        codigo: '5',
        titulo: 'Documentação',
        subgrupos: [
            {
                codigo: '5.1',
                titulo: 'Manual de boas práticas de fabricação',
                itens: [
                    { codigo: '5.1.1', descricao: 'Operações executadas no estabelecimento de acordo com o manual de boas práticas.' },
                ],
            },
            {
                codigo: '5.2',
                titulo: 'Programas de autocontrole',
                itens: [
                    { codigo: '5.2.1', descricao: 'Existência da descrição do PAC de manutenção das instalações e equipamentos.' },
                    { codigo: '5.2.2', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.3', descricao: 'Existência da descrição do PAC de água de abastecimento interno.' },
                    { codigo: '5.2.4', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.5', descricao: 'Existência da descrição do PAC de controle integrado de pragas, insetos e roedores.' },
                    { codigo: '5.2.6', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.7', descricao: 'Existência da descrição do PAC de manejo de resíduos sólidos e líquidos.' },
                    { codigo: '5.2.8', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.9', descricao: 'Existência da descrição do PAC de limpeza e sanitização (PPHO).' },
                    { codigo: '5.2.10', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.11', descricao: 'Existência da descrição do PAC de procedimentos sanitários das operações (PSO).' },
                    { codigo: '5.2.12', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.13', descricao: 'Existência da descrição do PAC de higiene, hábitos e saúde dos manipuladores.' },
                    { codigo: '5.2.14', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.15', descricao: 'Existência da descrição do PAC de matérias-primas, ingredientes e embalagens.' },
                    { codigo: '5.2.16', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.17', descricao: 'Existência da descrição do PAC de controle de temperaturas.' },
                    { codigo: '5.2.18', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.19', descricao: 'Existência da descrição do PAC de análises laboratoriais.' },
                    { codigo: '5.2.20', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.21', descricao: 'Existência da descrição do PAC de rastreabilidade e recolhimento.' },
                    { codigo: '5.2.22', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.23', descricao: 'Existência da descrição do PAC de bem-estar animal.' },
                    { codigo: '5.2.24', descricao: 'O PAC descrito está sendo cumprido.' },
                    { codigo: '5.2.25', descricao: 'Existência da descrição da APPCC.' },
                    { codigo: '5.2.26', descricao: 'O PAC descrito está sendo cumprido.' },
                ],
            },
        ],
    },
]